<template>
  <div>
    <div class="row">
      <div v-show="!productPanel" style="padding: 20px;">
        <button v-if="!showingAllProducts" @click.prevent="getProducts()" class="btn btn-fill btn-info">Back to All Products</button>
        <button v-if="showingAllProducts" @click.prevent="addProductPanel()" class="btn btn-fill btn-info">Add Single Product</button>
        <button v-if="showingAllProducts" @click.prevent="clickAmzImportBtn()" class="btn btn-fill btn-amzyellow">Import Amazon Products</button>
        <div class="col-md-4 pull-right">
          <div style="float: right;">
            <form role="search" class="navbar-form navbar-left navbar-search-form" _lpchecked="1">
              <div class="input-group"><input type="text" v-model="searchQuery" value="" placeholder="Search..." class="form-control" style="background-color: #fff;">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-show="productPanel" class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Add Product to {{ accountData.activeBrand.data.name }}</h4>
            <p v-if="prodSlotsRemaining > 0" class="category">You can add up to X more products on your Authentic.net Starter Plan.</p>
            <p v-if="prodSlotsRemaining === 0" class="text-danger">Please upgrade your Authentic.net plan if you wish to add more products.</p>
          </div>
          <div class="card-content">
            <form v-if="prodSlotsRemaining > 0" method="get" action="/" v-on:submit.prevent class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Name</label>
                  <div class="col-sm-10">
                    <input type="text" name="name" v-model="newProduct.name" v-validate="modelValidations.name" class="form-control" />
                    <small class="text-danger" v-show="name.invalid">
                      {{ getError('name') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Size</label>
                  <div class="col-sm-10">
                    <input type="text" name="size" v-model="newProduct.size" v-validate="modelValidations.size" class="form-control" />
                    <small class="text-danger" v-show="size.invalid">
                      {{ getError('size') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Color</label>
                  <div class="col-sm-10">
                    <input type="text" name="color" v-model="newProduct.color" v-validate="modelValidations.color" class="form-control" />
                    <small class="text-danger" v-show="color.invalid">
                      {{ getError('color') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Style</label>
                  <div class="col-sm-10">
                    <input type="text" name="style" v-model="newProduct.style" v-validate="modelValidations.style" class="form-control" />
                    <small class="text-danger" v-show="style.invalid">
                      {{ getError('style') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">SKU</label>
                  <div class="col-sm-10">
                    <input type="text" name="sku" v-model="newProduct.sku" v-validate="modelValidations.sku" class="form-control" />
                    <small class="text-danger" v-show="sku.invalid">
                      {{ getError('sku') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">UPC</label>
                  <div class="col-sm-10">
                    <input type="text" name="upc" v-model="newProduct.upc" v-validate="modelValidations.upc" class="form-control" />
                    <small class="text-danger" v-show="upc.invalid">
                      {{ getError('upc') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Amazon FNSKUs</label>
                  <div class="col-sm-10">
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com</label>
                      <input type="text" name="amazonComFnsku" v-model="newProduct.amazonComFnsku" v-validate="modelValidations.amazonComFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComFnsku.invalid">
                        {{ getError('amazonComFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.ca</label>
                      <input type="text" name="amazonCaFnsku" v-model="newProduct.amazonCaFnsku" v-validate="modelValidations.amazonCaFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCaFnsku.invalid">
                        {{ getError('amazonCaFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.mx</label>
                      <input type="text" name="amazonComMxFnsku" v-model="newProduct.amazonComMxFnsku" v-validate="modelValidations.amazonComMxFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComMxFnsku.invalid">
                        {{ getError('amazonComMxFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.cn</label>
                      <input type="text" name="amazonCnFnsku" v-model="newProduct.amazonCnFnsku" v-validate="modelValidations.amazonCnFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCnFnsku.invalid">
                        {{ getError('amazonCnFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.in</label>
                      <input type="text" name="amazonInFnsku" v-model="newProduct.amazonInFnsku" v-validate="modelValidations.amazonInFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonInFnsku.invalid">
                        {{ getError('amazonInFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.co.jp</label>
                      <input type="text" name="amazonCoJpFnsku" v-model="newProduct.amazonCoJpFnsku" v-validate="modelValidations.amazonCoJpFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCoJpFnsku.invalid">
                        {{ getError('amazonCoJpFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.sg</label>
                      <input type="text" name="amazonComSgFnsku" v-model="newProduct.amazonComSgFnsku" v-validate="modelValidations.amazonComSgFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComSgFnsku.invalid">
                        {{ getError('amazonComSgFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.tr</label>
                      <input type="text" name="amazonComTrFnsku" v-model="newProduct.amazonComTrFnsku" v-validate="modelValidations.amazonComTrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComTrFnsku.invalid">
                        {{ getError('amazonComTrFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.ae</label>
                      <input type="text" name="amazonAeFnsku" v-model="newProduct.amazonAeFnsku" v-validate="modelValidations.amazonAeFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonAeFnsku.invalid">
                        {{ getError('amazonAeFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.fr</label>
                      <input type="text" name="amazonFrFnsku" v-model="newProduct.amazonFrFnsku" v-validate="modelValidations.amazonFrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonFrFnsku.invalid">
                        {{ getError('amazonFrFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.de</label>
                      <input type="text" name="amazonDeFnsku" v-model="newProduct.amazonDeFnsku" v-validate="modelValidations.amazonDeFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonDeFnsku.invalid">
                        {{ getError('amazonDeFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.it</label>
                      <input type="text" name="amazonItFnsku" v-model="newProduct.amazonItFnsku" v-validate="modelValidations.amazonItFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonItFnsku.invalid">
                        {{ getError('amazonItFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.nl</label>
                      <input type="text" name="amazonNlFnsku" v-model="newProduct.amazonNlFnsku" v-validate="modelValidations.amazonNlFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonNlFnsku.invalid">
                        {{ getError('amazonNlFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.es</label>
                      <input type="text" name="amazonEsFnsku" v-model="newProduct.amazonEsFnsku" v-validate="modelValidations.amazonEsFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonEsFnsku.invalid">
                        {{ getError('amazonEsFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.co.uk</label>
                      <input type="text" name="amazonCoUkFnsku" v-model="newProduct.amazonCoUkFnsku" v-validate="modelValidations.amazonCoUkFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonCoUkFnsku.invalid">
                        {{ getError('amazonCoUkFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.au</label>
                      <input type="text" name="amazonComAuFnsku" v-model="newProduct.amazonComAuFnsku" v-validate="modelValidations.amazonComAuFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComAuFnsku.invalid">
                        {{ getError('amazonComAuFnsku') }}
                      </small>
                    </div>
                    <div class="col-sm-3">
                      <label class="fnsku-label">amazon.com.br</label>
                      <input type="text" name="amazonComBrFnsku" v-model="newProduct.amazonComBrFnsku" v-validate="modelValidations.amazonComBrFnsku" class="form-control" />
                      <small class="text-danger" v-show="amazonComBrFnsku.invalid">
                        {{ getError('amazonComBrFnsku') }}
                      </small>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    <i v-tooltip="prodLandingUrlTip" class="ti-help" style="font-size: 1em;"></i>
                    Thank You / Landing Page
                  </label>
                  <div class="col-sm-10">
                    <input type="text" name="redirectUrl" v-model="newProduct.redirectUrl" v-validate="modelValidations.redirectUrl" class="form-control" />
                    <small class="text-danger" v-show="redirectUrl.invalid">
                      {{ getError('redirectUrl') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Image</label>
                  <div class="col-sm-10">
                    <button type="button" v-show="!loading && !imageUploaded" class="btn btn-wd btn-info" @click="clickImageFile">
                      <span class="btn-label">
                        <i class="fa fa-plus"></i>
                      </span>
                      Add Photo
                    </button>
                    <div v-if="uploading" style="padding-top: 20px;">
                      <p-progress :value="uploadProgress" type="info"></p-progress>
                    </div>
                    <div v-if="!uploading && imageUploaded" style="padding-top: 10px;"><i class="fa fa-check"></i>{{ imageFileOgName }}</div>
                    <input v-show="false" ref="imageFile" type="file" name="imageFile" accept="image/*" @change="selectFile">
                    <input v-show="false" type="text" name="image" v-model="newProduct.image" v-validate="modelValidations.image"  class="form-control" />
                    <small class="text-danger" v-show="image.invalid">
                      {{ getError('image') }}
                    </small>
                  </div>
                </div>
              </fieldset>
              
              <button type="submit" v-if="!loading" @click.prevent="validateAddProduct()" class="btn btn-fill btn-info">Submit</button>
              <button type="button" v-if="loading" class="btn btn-wd btn-info" disabled="disabled">
                <span class="btn-label">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
                Submit
              </button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>

    <div class="row">
      <div v-for="prod in productsTable" class="col-lg-3" :key="prod.id">
        <div v-if="!prod.isParent" class="card" style="padding-top:10px;">
          <div class="text-center" style="height: 80px; padding: 0px 10px;">
            <h5 v-tooltip="prod.name">{{limitChars(prod.name)}}</h5>
          </div>
          <div class="text-center" style="height: 140px; display: flex; align-items: center;">
            <div class="img-container">
              <router-link :to="{ name: 'Product Dashboard', params: { id: prod.id }}">
                <img v-if="prod.image" :src="prod.image" :alt="prod.name">
                <span v-if="!prod.image">{NO PRODUCT LOGO}</span>
              </router-link>
            </div>
          </div>
          <div class="text-center" style="height: 120px;">
            <div v-if="prod.size">
              <strong>Size:</strong> {{prod.size}}
            </div>
            <div v-if="prod.color">
              <strong>Color:</strong> {{prod.color}}
            </div>
            <div v-if="prod.style">
              <strong>Style:</strong> {{prod.style}}
            </div>
            <div v-if="prod.sku">
              <strong>SKU:</strong> {{prod.sku}}
            </div>
            <div v-if="prod.upc">
              <strong>UPC:</strong> {{prod.upc}}
            </div>
            <div v-if="prod.amazonComFnsku">
              <strong>AMZ FBA FNSKU:</strong> {{prod.amazonComFnsku}}
            </div>
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <router-link tag="button" :to="{ name: 'Product', params: { productId: prod.id }}" class="btn btn-fill btn-info btn-sm">Edit</router-link>
            <button type="button" v-if="!prod.deleting && !prod.isArchived" @click.prevent="deleteProd(prod)" class="btn btn-fill btn-danger btn-sm">Delete</button>
            <button type="button" v-if="prod.deleting" class="btn btn-danger btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Deleting...
            </button>
            <button type="button" v-if="prod.isArchived && !prod.unarchiving" @click.prevent="unArchiveProduct(prod)" class="btn btn-fill btn-sm">Un-Archive</button>
            <button type="button" v-if="prod.unarchiving" class="btn btn-fill btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Un-Archiving...
            </button>
            <router-link tag="button" :to="{ name: 'Make Authentic.net Codes', params: { productId: prod.id }}" class="btn btn-fill btn-sm">Make Auth Codes</router-link>
          </div>
        </div>
        <div v-if="prod.isParent" class="card" style="padding-top:10px;">
          <div class="text-center" style="height: 80px; padding: 0px 10px;">
            <h5 v-tooltip="prod.name">{{limitChars(prod.name)}}</h5>
          </div>
          <div class="text-center" style="height: 140px; display: flex; align-items: center;">
            <div class="img-container">
              <router-link :to="{ name: 'Product Dashboard', params: { id: prod.id }}">
                <img v-if="prod.image" :src="prod.image" :alt="prod.name">
                <span v-if="!prod.image">{NO PRODUCT LOGO}</span>
              </router-link>
            </div>
          </div>
          <div class="text-center" style="height: 120px;">
            &nbsp;
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <button type="button" @click.prevent="getVariantProducts(prod.name)" class="btn btn-fill btn-info btn-sm">View All Variations</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 pull-right">
        <div style="float: right;">
          <p class="category">Show Archived Products</p>
          <p-switch v-model="showArchived" type="primary" on-text="ON" off-text="OFF"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {Table, TableColumn, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import _ from 'lodash'
  import algoliasearch from 'algoliasearch'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  const algolia = algoliasearch(
    'RQUCV3WZ1Q',
    '1f59c67aacc900322f92fb575c71e5c0'
  )
  // var storageRef = firebase.storage().ref()
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch,
      PProgress,
      [Select.name]: Select
    },
    props: ['accountData'],
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['image',
        'name',
        'size',
        'color',
        'style',
        'amazonComFnsku',
        'amazonCaFnsku',
        'amazonComMxFnsku',
        'amazonCnFnsku',
        'amazonInFnsku',
        'amazonCoJpFnsku',
        'amazonComSgFnsku',
        'amazonComTrFnsku',
        'amazonAeFnsku',
        'amazonFrFnsku',
        'amazonDeFnsku',
        'amazonItFnsku',
        'amazonNlFnsku',
        'amazonEsFnsku',
        'amazonCoUkFnsku',
        'amazonComAuFnsku',
        'amazonComBrFnsku',
        'sku',
        'upc',
        'redirectUrl'])
    },
    data () {
      return {
        user: {
          email: '',
          token: ''
        },
        newProduct: {
          image: '',
          name: '',
          brandIndex: '',
          size: '',
          color: '',
          style: '',
          sku: '',
          upc: '',
          redirectUrl: ''
        },
        imageFile: '',
        imageFileOgName: '',
        imageUploaded: false,
        uploadProgress: 0,
        uploading: false,
        loading: false,
        prodSlotsRemaining: 2,
        modelValidations: {
          image: {
            required: false,
            url: true
          },
          name: {
            required: true,
            max: 26
          },
          size: {
            required: false
          },
          color: {
            required: false
          },
          style: {
            required: false
          },
          amazonComFnsku: {
            required: false
          },
          amazonCaFnsku: {
            required: false
          },
          amazonComMxFnsku: {
            required: false
          },
          amazonCnFnsku: {
            required: false
          },
          amazonInFnsku: {
            required: false
          },
          amazonCoJpFnsku: {
            required: false
          },
          amazonComSgFnsku: {
            required: false
          },
          amazonComTrFnsku: {
            required: false
          },
          amazonAeFnsku: {
            required: false
          },
          amazonFrFnsku: {
            required: false
          },
          amazonDeFnsku: {
            required: false
          },
          amazonItFnsku: {
            required: false
          },
          amazonNlFnsku: {
            required: false
          },
          amazonEsFnsku: {
            required: false
          },
          amazonCoUkFnsku: {
            required: false
          },
          amazonComAuFnsku: {
            required: false
          },
          amazonComBrFnsku: {
            required: false
          },
          sku: {
            required: false
          },
          upc: {
            required: false
          },
          redirectUrl: {
            required: false,
            url: {
              require_protocol: true
            }
          }
        },
        productsTable: [],
        prodIdIndexMap: new Map(),
        productsTableKey: this.$uuid.v4(),
        brands: [],
        showArchived: false,
        productPanel: false,
        showingAllProducts: true,
        newProdId: this.$uuid.v4(),
        prodLandingUrlTip: 'If provided, then anyone who submits a registration for this product will be redirected to this URL after submission.',
        searchQuery: ''
      }
    },
    methods: {
      async init () {
        this.brands = this.accountData.brands
        this.user = this.accountData.authDetails.user
        this.getProducts()
      },
      limitChars (x) {
        if (x.length > 90) return x.substring(0, 87) + '...'
        return x
      },
      clickImageFile () {
        this.$refs.imageFile.click()
      },
      addProductPanel () {
        this.productPanel = true
      },
      selectFile () {
        this.imageFile = this.$refs.imageFile.files[0]
        this.imageFileOgName = this.imageFile.name
        this.uploadFile()
      },
      uploadFile () {
        this.loading = true
        this.uploading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + this.imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`brands/${this.accountData.activeBrand.id}/products/${this.newProdId}/${filename}`).put(this.imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.uploadProgress = progress
            if (progress === 100) {
              this.imageUploaded = true
            }
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.loading = false
              this.uploading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              console.log('File available at', downloadURL)
              this.newProduct.image = downloadURL
              this.loading = false
              this.uploading = false
            })
          })
      },
      async getProducts () {
        this.showingAllProducts = true
        this.productsTable = []
        this.prodIdIndexMap = new Map()
        let path = `brands/${this.accountData.activeBrand.id}/products`
        let qs = await db.collection(path).orderBy('name').get()
        for (const prod of qs.docs) {
          if (!this.showArchived && prod.data().isArchived) continue
          let samePrevProd = _.find(this.productsTable, { name: prod.data().name })
          if (samePrevProd !== undefined) {
            samePrevProd.isParent = true
          } else {
            let product = prod.data()
            product.id = prod.id
            product.image = await this.prodImgUrl(prod.id, prod.data(), '140x140')
            this.productsTable.push(product)
            this.prodIdIndexMap.set(prod.id, this.productsTable.length - 1)
          }
        }
      },
      async getVariantProducts (productName) {
        this.showingAllProducts = false
        this.productsTable = []
        this.prodIdIndexMap = new Map()
        let path = `brands/${this.accountData.activeBrand.id}/products`
        let qs = await db.collection(path).where('name', '==', productName).get()
        for (const prod of qs.docs) {
          if (!this.showArchived && prod.data().isArchived) continue
          let product = prod.data()
          product.id = prod.id
          product.image = await this.prodImgUrl(prod.id, prod.data(), '140x140')
          this.productsTable.push(product)
          this.prodIdIndexMap.set(prod.id, this.productsTable.length - 1)
        }
      },
      async addProduct () {
        let product = this.newProduct
        product.imageUrl = this.newProduct.image
        product.brandId = this.accountData.activeBrand.id
        product.qtyCertified = 0
        product.qtyValidated = 0
        product.qtyFraudReports = 0
        try {
          await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(this.newProdId).set(product)
          product.id = this.newProdId
          product.image = await this.prodImgUrl(this.newProdId, product, '140x140')
          this.productsTable.push(product)
          this.loading = false
          this.productPanel = false
          this.newProduct = {
            image: '',
            name: '',
            brandIndex: '',
            size: '',
            color: '',
            style: '',
            sku: '',
            upc: '',
            amazonComFnsku: '',
            redirectUrl: ''
          }
          this.newProdId = this.$uuid.v4()
        } catch (err) {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        }
      },
      validateAddProduct () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.addProduct()
          } else {
            this.loading = false
          }
        })
      },
      pushProduct () {
        let newProduct = {
          image: this.newProduct.image,
          title: this.newProduct.title,
          certified_qty: 0,
          validated_qty: 0,
          fruad_reports: 0
        }
        this.productsTable.unshift(newProduct)
        this.newProduct.image = ''
        this.newProduct.title = ''
        this.prodSlotsRemaining--
        swal.fire({
          title: `Added`,
          text: newProduct.title,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
      },
      async deleteProd (prod) {
        try {
          let prodId = prod.id
          prod.deleting = true
          this.productsTableKey = this.$uuid.v4()
          let data = {}
          data.userToken = await firebase.auth().currentUser.getIdToken()
          data.accountId = this.user.accountId
          data.brandId = this.accountData.activeBrand.id
          data.productId = prodId
          let accountDeleteProduct = firebase.functions().httpsCallable('accountDeleteProduct')
          let result = await accountDeleteProduct(data)
          prod.deleting = false
          this.showNotify(`Product ${prod.name} deleted.`, 'success', 'Success')
          this.productsTable.splice(this.prodIdIndexMap.get(prodId), 1)
        } catch (err) {
          console.log(err)
          prod.deleting = false
          this.productsTableKey = this.$uuid.v4()
          swal.fire({
            title: 'Cannot Be Deleted',
            text: `This product cannot be deleted as it contains existing Authentic.net codes. Would you like to archive it instead?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-info btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, archive it!',
            buttonsStyling: false
          }).then(async (result) => {
            if (result.value) await this.archiveProduct(prod)
          })
        }
      },
      async archiveProduct (product) {
        await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(product.id).update({ isArchived: true })
        product.isArchived = true
        if (!this.showArchived) this.productsTable.splice(this.prodIdIndexMap.get(product.id), 1)
        this.showNotify(`Product ${product.name} archived.`, 'success', 'Success')
        // this.getProducts()
      },
      async unArchiveProduct (product) {
        console.log('unarchiving')
        product.unarchiving = true
        this.productsTableKey = this.$uuid.v4()
        await db.collection(`brands/${this.accountData.activeBrand.id}/products`).doc(product.id).update({ isArchived: false })
        product.isArchived = false
        product.unarchiving = false
        if (this.showArchived) this.productsTable.splice(this.prodIdIndexMap.get(product.id), 1)
        this.productsTableKey = this.$uuid.v4()
        this.showNotify(`Product ${product.name} un-archived.`, 'success', 'Success')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      getSummaries (param) {
        const { columns } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.productsTable.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      },
      async clickAmzImportBtn () {
        let path = `accounts/${this.accountData.authDetails.account.id}/amzProducts`
        console.log('getting amzProduct', path)
        let qs = await db.collection(path).limit(1).get()
        if (qs.empty) {
          swal.fire({
            title: 'Amazon Not Connected',
            text: 'Please add your Amazon API details to your account page.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(() => {
            this.$router.replace({ name: 'Account' })
          })
        } else {
          this.$router.replace({ name: 'Amazon' })
        }
      },
      async searchProducts (query) {
        if (query === '') {
          this.getProducts()
        } else {
          let index = algolia.initIndex(`brands_${this.accountData.activeBrand.id}_products`)
          let result = await index.search(query)
          this.showingAllProducts = true
          this.productsTable = []
          this.prodIdIndexMap = new Map()
          for (const prodData of result.hits) {
            if (!this.showArchived && prodData.isArchived) continue
            let samePrevProd = _.find(this.productsTable, { name: prodData.name })
            if (samePrevProd !== undefined) {
              samePrevProd.isParent = true
            } else {
              let product = prodData
              product.id = prodData.objectID
              product.image = await this.prodImgUrl(prodData.objectID, prodData, '140x140')
              this.productsTable.push(product)
              this.prodIdIndexMap.set(prodData.objectID, this.productsTable.length - 1)
            }
          }
        }
      }
    },
    watch: {
      showArchived: function (newFrom, oldFrom) {
        this.getProducts()
      },
      searchQuery: function (newFrom, oldFrom) {
        this.searchProducts(newFrom)
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.img-container {
  max-width: 140px;
  max-height: 140px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Products.vue